



import {Component, Vue} from 'vue-property-decorator';
import ForgotPasswordForm from "@/components/Molecules/ForgotPasswordForm/ForgotPasswordForm.vue";
import {ForgotPasswordFormDto, ForgotPasswordFormType} from "@/share";
import {ServiceFactory} from "@/services";

const AuthService = ServiceFactory.get('auth');

@Component({
  components: {
    ForgotPasswordForm,
  }
})
export default class ForgotPassword extends Vue {

  private errors = []
  private isLoading = false

  private async forgotPassword(formData: ForgotPasswordFormType): Promise<any> {
    const {email} = formData
    const data: ForgotPasswordFormDto = new ForgotPasswordFormDto({
      email: email || '',
    })

    this.errors = []
    this.isLoading = true
    let response = await AuthService.forgotPassword(data).catch(() => [])
    this.isLoading = false

    if (response.hasError) return this.errors = response.errors
    return this.$router.push({name: 'routes.auth.resetPasswordSuccess'})
  }
}
